import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { MatchingGate } from '../features/matching/MatchingGate';
import { AdminPage } from '../pages/Admin/AdminPage';
import { EventDetailPage } from '../pages/EventDetail/EventDetailPage';
import { EventFormPage } from '../pages/EventForm/EventFormPage';
import { EventsDashboardPage } from '../pages/EventsDashboard/EventsDashboardPage';
import { FloorPlanPage } from '../pages/FloorPlan/FloorPlanPage';
import { ResourceEventsPage } from '../pages/FloorPlan/ResourceEventsPage';
import { GameDetailPage } from '../pages/Games/GameDetailPage';
import { GameFormPage } from '../pages/Games/GameFormPage';
import { GamesPage } from '../pages/Games/GamesPage';
import { GroupFormPage } from '../pages/GroupForm/GroupFormPage';
import { GroupsDashboardPage } from '../pages/GroupsDashboard/GroupsDashboardPage';
import { GuestAccessFormPage } from '../pages/GuestAccess/GuestAccessFormPage';
import { GuestAccessPage } from '../pages/GuestAccess/GuestAccessPage';
import { MatchingBoardPage } from '../pages/MatchingBoard/MatchingBoardPage';
import { MatchingRequestPage } from '../pages/MatchingRequest/MatchingRequestPage';
import { NotificationsPage } from '../pages/Notifications/NotificationsPage';
import { ProfilePage } from '../pages/Profile/ProfilePage';
import { UsersPage } from '../pages/Users/UsersPage';
import { WelcomePage } from '../pages/Welcome/WelcomePage';

import { AppShell } from './shell/AppShell';
import { FormShell } from './shell/FormShell';

export const router = createBrowserRouter([
  {
    element: <FormShell />,
    children: [
      { path: '/events/new', element: <EventFormPage /> },
      { path: '/events/:eventId/edit', element: <EventFormPage /> },
      { path: '/games/new', element: <GameFormPage /> },
      { path: '/games/:gameId/edit', element: <GameFormPage /> },
      { path: '/groups/new', element: <GroupFormPage /> },
      { path: '/groups/:groupId/edit', element: <GroupFormPage /> },
      { path: '/guests/new', element: <GuestAccessFormPage /> },
      { path: '/guests/:ruleId/edit', element: <GuestAccessFormPage /> },
      {
        path: '/gathering/new',
        element: (
          <MatchingGate>
            <MatchingRequestPage />
          </MatchingGate>
        ),
      },
      {
        path: '/gathering/:id/edit',
        element: (
          <MatchingGate>
            <MatchingRequestPage />
          </MatchingGate>
        ),
      },
    ],
  },
  {
    element: <AppShell />,
    children: [
      { path: '/', element: <WelcomePage /> },
      { path: '/floor-plan', element: <FloorPlanPage /> },
      { path: '/floor-plan/:resourceId', element: <ResourceEventsPage /> },
      { path: '/events', element: <EventsDashboardPage /> },
      { path: '/events/:eventId', element: <EventDetailPage /> },
      {
        path: '/gathering',
        element: (
          <MatchingGate>
            <MatchingBoardPage />
          </MatchingGate>
        ),
      },
      { path: '/groups', element: <GroupsDashboardPage /> },
      { path: '/games', element: <GamesPage /> },
      { path: '/games/:gameId', element: <GameDetailPage /> },
      { path: '/users', element: <UsersPage /> },
      { path: '/profile', element: <ProfilePage /> },
      { path: '/profile/notifications', element: <NotificationsPage /> },
      { path: '/admin', element: <AdminPage /> },
      { path: '/guests', element: <GuestAccessPage /> },
    ],
  },
]);
